'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var jsxRuntime = require('react/jsx-runtime');
var ui = require('@xcorejs/ui');
var react = require('react');
var isPlainObject = require('is-plain-object');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var xcoreCore = require('@appiodev/xcore-core');
var _typeof = require('@babel/runtime/helpers/typeof');
var xcoreUtils = require('@appiodev/xcore-utils');
var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var router = require('next/router');
var NextLink = require('next/link');
var _getSlug = require('speakingurl');
var styled = require('styled-components');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _regeneratorRuntime = require('@babel/runtime/regenerator');
var useSWR = require('swr');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var NextLink__default = /*#__PURE__*/_interopDefaultLegacy(NextLink);
var _getSlug__default = /*#__PURE__*/_interopDefaultLegacy(_getSlug);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var useSWR__default = /*#__PURE__*/_interopDefaultLegacy(useSWR);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var nodeToString = function nodeToString(node) {
  if (isText(node)) {
    return node.text;
  } else {
    return node.children.map(nodeToString).join("");
  }
};
var isText = function isText(node) {
  return isPlainObject.isPlainObject(node) && typeof node.text === "string";
};

/** Same as useState but supports second argument to reset the state when the input changes */

var useDerivedState = function useDerivedState(initialState, deps) {
  var ref = react.useRef();

  var _useState = react.useState(initialState),
      _useState2 = _slicedToArray__default['default'](_useState, 2),
      state = _useState2[0],
      set = _useState2[1]; // eslint-disable-next-line react-hooks/exhaustive-deps


  react.useEffect(function () {
    return set(initialState);
  }, deps);
  var returnValue = ref.current === undefined || state === initialState || areHookInputsEqual(deps, ref.current) ? state : evaluateState(initialState);
  ref.current = deps;
  return [returnValue, set];
};

var areHookInputsEqual = function areHookInputsEqual(nextDeps, prevDeps) {
  if (nextDeps.length !== prevDeps.length) {
    return false;
  }

  for (var i = 0; i < prevDeps.length && i < nextDeps.length; i++) {
    if (Object.is(nextDeps[i], prevDeps[i])) {
      continue;
    }

    return false;
  }

  return true;
};

var evaluateState = function evaluateState(s) {
  return typeof s === "function" ? s() : s;
};

var xcoreDataUtils = function xcoreDataUtils(cms) {
  return {
    stringify: stringify(cms.locales.content),
    localize: localize(cms.locales.content),
    value: value(),
    formatDate: formatDate(cms.locales.content),
    file: fileFunc(cms),
    richtextToString: richtextToString(cms.locales.content),
    title: title(cms.locales.content)
  };
};

var fileFunc = function fileFunc(cms) {
  return function (val) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return cms.files.getFileUrl(value()(val), options);
  };
};

var formatDate = function formatDate(locales) {
  var validLocales = locales.filter(function (l) {
    try {
      // eslint-disable-next-line no-new
      new Intl.DateTimeFormat(l);
      return true;
    } catch (e) {
      return false;
    }
  });
  return function (date) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$locale = _ref.locale,
        locale = _ref$locale === void 0 ? validLocales[0] : _ref$locale,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? "date" : _ref$type;

    var _a, _b;

    var val = value()(date);
    var d = typeof val === "string" ? new Date(val) : val;
    var method = {
      date: "toLocaleDateString",
      time: "toLocaleTimeString",
      datetime: "toLocaleString"
    }; // TODO: implement different solution, this is temporary

    var locs = {
      "en": "de-DE",
      "en-SEA": "de-DE",
      "en-NA": "en-US"
    };
    return d[method[type]]((_b = (_a = locs[locale]) !== null && _a !== void 0 ? _a : locale) !== null && _b !== void 0 ? _b : validLocales);
  };
};

var richtextToString = function richtextToString(locales) {
  return function (input) {
    var newline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "\n";
    var stripped = value()(input);
    if (stripped === undefined) return undefined;
    var richtext = isRichtext(stripped) ? stripped : localize(locales)(stripped);
    return richtext === null || richtext === void 0 ? void 0 : richtext.value.map(nodeToString).join(newline);
  };
};

var localize = function localize(locales) {
  return function (_val) {
    var val = value()(_val);
    return xcoreUtils.resolveLocale(locales)(val);
  };
};

var value = function value() {
  return function (v) {
    return _typeof__default['default'](v) === "object" && v && v.__handler ? v.__handler[0] : v;
  };
};

var stringify = function stringify(locales) {
  return function (val) {
    var strippedValue = value()(val);
    if (strippedValue === undefined || typeof strippedValue === "string") return strippedValue;
    var result = localize(locales)(strippedValue);
    if (result === undefined) return undefined;

    if (typeof result !== "string") {
      console.warn("Invalid stringify input (input, result):", val, result);
      return "";
    }

    return result;
  };
};

var title = function title(locales) {
  return function (content) {
    return typeof content.title === "string" ? content.title : xcoreUtils.resolveLocale(locales)(content.title);
  };
};

var isRichtext = function isRichtext(x) {
  return x && _typeof__default['default'](x) === "object" && "value" in x && Array.isArray(x.value);
};

var ReactRequestContext = /*#__PURE__*/react.createContext(null);
var RequestContextProvider = ReactRequestContext.Provider;

var XcoreDataContext = /*#__PURE__*/react.createContext(null);
var XcoreClientProvider = function XcoreClientProvider(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  var _useDerivedState = useDerivedState(function () {
    return props.content;
  }, [props.content]),
      _useDerivedState2 = _slicedToArray__default['default'](_useDerivedState, 2),
      content = _useDerivedState2[0],
      setContent = _useDerivedState2[1];

  var context = react.useMemo(function () {
    var config = new xcoreCore.XcoreConfig(props.config);
    var cms = new xcoreCore.XcoreCMS(props.ctx);
    var resolvedDomains = config.getResolvedDomains("");
    return Object.assign(Object.assign(Object.assign({}, props), xcoreDataUtils(cms)), {
      cms: cms,
      config: config,
      resolvedDomains: resolvedDomains,
      content: content,
      setContent: setContent
    });
  }, [props, content, setContent]);
  return jsxRuntime.jsx(XcoreDataContext.Provider, Object.assign({
    value: context
  }, {
    children: jsxRuntime.jsx(RequestContextProvider, Object.assign({
      value: props.ctx
    }, {
      children: children
    }))
  }));
};

/** useData returns content of the xcore context with SSG/SSR props and utilities */

var useData = function useData() {
  var data = react.useContext(XcoreDataContext);
  return Object.assign(Object.assign({}, data), {
    setContent: data ? data.setContent : function () {
      return console.warn("[xcore client] Trying to set content outside of context");
    }
  });
};

var SlateValue = function SlateValue(_a) {
  var value = _a.value,
      content = _a.content,
      elementProps = _a.elementProps,
      props = __rest(_a, ["value", "content", "elementProps"]);

  return jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: value.map(function (n, i) {
      return jsxRuntime.jsx(react.Fragment, {
        children: isText(n) ? props.renderLeaf(elementProps)({
          children: n.text,
          text: n,
          leaf: n,
          attributes: {}
        }) : props.renderElement(elementProps, content)({
          children: jsxRuntime.jsx(SlateValue, Object.assign({}, props, {
            content: content,
            value: n.children,
            elementProps: elementProps
          })),
          element: n,
          attributes: {}
        })
      }, i);
    })
  });
};
var useSlateValue = function useSlateValue(richtext) {
  var _useData = useData(),
      cms = _useData.cms,
      value = _useData.value;

  return react.useMemo(function () {
    var stripped = value(richtext);
    return stripped === undefined ? stripped : stripped && "links" in stripped ? stripped : xcoreUtils.resolveLocale(cms.locales.content)(stripped);
  }, [value, richtext, cms.locales.content]);
};

var _throw = function _throw(e) {
  throw typeof e === "string" ? new Error(e) : e;
};

var logError = function logError(e) {
  var throwInProd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (process.env.NODE_ENV !== "production" || throwInProd === true) _throw(e);
  if (throwInProd === "warn") console.warn(e instanceof Error ? e : new Error(e));
};
var logWarn = function logWarn(e, color) {
  console.warn(color ? "\x1B[33m".concat(String(e), "\x1B[0m") : e instanceof Error ? e : new Error(e));
};

var joinUrlPaths = function joinUrlPaths(p) {
  for (var _len = arguments.length, paths = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    paths[_key - 1] = arguments[_key];
  }

  return trimTrailingSlash(paths.reduce(function (a, b) {
    return a.endsWith("/") && b.startsWith("/") ? a + b.slice(1) : !a.endsWith("/") && !b.startsWith("/") ? "".concat(a, "/").concat(b) : "".concat(a).concat(b);
  }, p));
};
var resolveLocaleDomain = function resolveLocaleDomain(_ref, options) {
  var cms = _ref.cms,
      config = _ref.config,
      resolvedDomains = _ref.resolvedDomains;

  var _a;

  var l = cms.locales.content;
  var d;
  options.domain && options.locale && logLinkError("Options should not contain both domain and locale.");

  if (options.locale) {
    l = config.locales[options.locale].content;
    d = (_a = Object.entries(resolvedDomains).find(function (_ref2) {
      var _ref3 = _slicedToArray__default['default'](_ref2, 2),
          loc = _ref3[1];

      return loc === options.locale;
    })) === null || _a === void 0 ? void 0 : _a[0];
    (!l || !d) && logLinkError("Invalid locale in link options.");
  }

  if (options.domain) {
    l = config.locales[resolvedDomains[options.domain]].content;
    d = options.domain;
    !l && logLinkError("Invalid domain in link options.");
  }

  return [l, d];
};

var trimTrailingSlash = function trimTrailingSlash(s) {
  return s === "/" ? "/" : s.endsWith("/") ? s.slice(0, -1) : s;
};

var logLinkError = function logLinkError(e, throwInProd) {
  return logError("<Link> or useLink: ".concat(e), throwInProd);
};
var logLinkWarn = function logLinkWarn(e) {
  return logWarn("<Link> or useLink: ".concat(e));
};

var as = function as(data) {
  return function (content) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _a;

    var _resolveLocaleDomain = resolveLocaleDomain(data, options),
        _resolveLocaleDomain2 = _slicedToArray__default['default'](_resolveLocaleDomain, 2),
        l = _resolveLocaleDomain2[0],
        d = _resolveLocaleDomain2[1];

    var base = getUrlBase(d);

    var _routeSlugPairFromCon = routeSlugPairFromContent(content, l, data.contentTypes),
        _routeSlugPairFromCon2 = _slicedToArray__default['default'](_routeSlugPairFromCon, 2),
        slug = _routeSlugPairFromCon2[0],
        route = _routeSlugPairFromCon2[1];

    var query = (_a = options.query) !== null && _a !== void 0 ? _a : "";
    return joinUrlPaths(base, resolveRoutePath(route.fromPath, content.id, slug)) + query;
  };
};

var getUrlBase = function getUrlBase(domain) {
  return domain !== undefined ? domain.startsWith("/") ? domain : "//" + domain : "";
};

var routeSlugPairFromContent = function routeSlugPairFromContent(content, locales, contentTypes) {
  var contentType = contentTypes[content.type];

  if (!contentType) {
    logLinkError("Failed to create a link, content.type \"".concat(content.type, "\" is not a valid content type."), "warn");
    return resolveErrorContent(ERROR404_CONTENT_TYPE_NAME, locales, contentTypes);
  }

  if (!contentType.routes || !Object.keys(contentType.routes).length) {
    logLinkError("Failed to create a link, content \"".concat(contentType.id, "\" is not routable. ").concat("Content id: " + content.id));
    return resolveErrorContent(ERROR404_CONTENT_TYPE_NAME, locales, contentTypes);
  }

  var slug = getSlug(content, locales);
  var route = xcoreCore.resolveLocale(locales)(contentType.routes);

  if (slug === "") {
    logLinkWarn("Content ".concat(content.id, " has empty string as a slug."));
  }

  if (!route) {
    return resolveErrorContent(ERROR404_CONTENT_TYPE_NAME, locales, contentTypes);
  }

  if (validateRouteSlugPair(route, content.id, slug)) {
    return [slug, route];
  } else {
    return resolveErrorContent(UNAVAILABLE_LOCALE_CONTENT_TYPE_NAME, locales, contentTypes);
  }
};

var resolveErrorContent = function resolveErrorContent(name, locales, contentTypes) {
  if (!contentTypes[name]) logLinkError("\"".concat(name, "\" content type was not found."), true);
  var routes = contentTypes[name].routes;
  var route = routes && xcoreCore.resolveLocale(locales)(routes);
  if (!route) logLinkError("\"".concat(name, "\" content type is missing route for ").concat(JSON.stringify(locales), " locales."), true);
  return [undefined, route];
};

var getSlug = function getSlug(content, locales) {
  return typeof content.slug === "string" ? content.slug : content.slug && xcoreCore.resolveLocale(locales)(content.slug);
};

var ID_REGEX = /\[id]|{id}/g;
var SLUG_REGEX = /\{slug}|\[slug]/g;
var resolveRoutePath = function resolveRoutePath(path, id, slug) {
  path = id ? path.replace(ID_REGEX, String(id)) : path;
  path = slug ? path.replace(SLUG_REGEX, String(slug)) : path;
  return path;
};

var validateRouteSlugPair = function validateRouteSlugPair(route, id, slug) {
  if ((ID_REGEX.exec(route.fromPath) || ID_REGEX.exec(route.toPath)) && !id) {
    logLinkWarn("Route ".concat(route.fromPath, " -> ").concat(route.toPath, " contains id placeholder, but the id has value \"").concat(id, "\"."));
    return false;
  }

  if ((SLUG_REGEX.exec(route.fromPath) || SLUG_REGEX.exec(route.toPath)) && !slug) {
    logLinkWarn("Path ".concat(route.fromPath, " -> ").concat(route.toPath, " contains slug placeholder, but the slug has value \"").concat(slug, "\"."));
    return false;
  }

  return true;
};

var href = function href(data) {
  return function (content) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _resolveLocaleDomain = resolveLocaleDomain(data, options),
        _resolveLocaleDomain2 = _slicedToArray__default['default'](_resolveLocaleDomain, 1),
        l = _resolveLocaleDomain2[0];

    var _routeSlugPairFromCon = routeSlugPairFromContent(content, l, data.contentTypes),
        _routeSlugPairFromCon2 = _slicedToArray__default['default'](_routeSlugPairFromCon, 2),
        slug = _routeSlugPairFromCon2[0],
        route = _routeSlugPairFromCon2[1];

    var hrefPath = route.toPath.replace("{id}", "[id]").replace("{slug}", "[slug]");
    return "".concat(hrefPath).concat(buildHrefQuery(removeHash(options.query), hrefPath.match(ID_REGEX$1) ? content.id : undefined, hrefPath.match(SLUG_REGEX$1) ? slug : undefined));
  };
};
var ID_REGEX$1 = /\[id]|{id}/g;
var SLUG_REGEX$1 = /\{slug}|\[slug]/g;

var buildHrefQuery = function buildHrefQuery(q, id, slug) {
  var appendix = [id ? "id=".concat(id) : "", slug ? "slug=".concat(slug) : ""].filter(Boolean).join("&");
  if (q && appendix) return "".concat(q, "&").concat(appendix);
  if (!q && appendix) return "?".concat(appendix);
  return q !== null && q !== void 0 ? q : "";
};

var removeHash = function removeHash(q) {
  return q === null || q === void 0 ? void 0 : q.replace(/#.*$/, "");
};

var ERROR404_CONTENT_TYPE_NAME = "error404";
var UNAVAILABLE_LOCALE_CONTENT_TYPE_NAME = "unavailableLocaleError";
var createXcoreLink = function createXcoreLink(contextData) {
  return {
    href: href(contextData),
    as: as(contextData)
  };
};

var useLink = function useLink() {
  var _useRouter = router.useRouter(),
      routerPush = _useRouter.push,
      routerReplace = _useRouter.replace;

  var _useData = useData(),
      config = _useData.config,
      cms = _useData.cms,
      resolvedDomains = _useData.resolvedDomains,
      contentTypes = _useData.contentTypes;

  return react.useMemo(function () {
    var _createXcoreLink = createXcoreLink({
      config: config,
      cms: cms,
      resolvedDomains: resolvedDomains,
      contentTypes: contentTypes
    }),
        as = _createXcoreLink.as,
        href = _createXcoreLink.href;

    var link = function link(content) {
      var _a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var query = _a.query,
          domain = _a.domain,
          locale = _a.locale,
          trans = __rest(_a, ["query", "domain", "locale"]);

      return [href(content, {
        query: query,
        domain: domain,
        locale: locale
      }), as(content, {
        query: query,
        domain: domain,
        locale: locale
      }), Object.assign({
        locale: locale
      }, trans)];
    };

    var push = function push(content) {
      var trans = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return routerPush.apply(void 0, _toConsumableArray__default['default'](link(content, trans)));
    };

    var replace = function replace(content) {
      var trans = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return routerReplace.apply(void 0, _toConsumableArray__default['default'](link(content, trans)));
    };

    return {
      href: href,
      as: as,
      link: link,
      push: push,
      replace: replace
    };
  }, [cms, config, contentTypes, resolvedDomains, routerPush, routerReplace]);
};

var Link = function Link(_a) {
  var content = _a.content,
      query = _a.query,
      noUILink = _a.noUILink,
      _a$as = _a.as,
      As = _a$as === void 0 ? ui.Link : _a$as,
      domain = _a.domain,
      locale = _a.locale,
      replace = _a.replace,
      scroll = _a.scroll,
      shallow = _a.shallow,
      _a$prefetch = _a.prefetch,
      prefetch = _a$prefetch === void 0 ? false : _a$prefetch,
      children = _a.children,
      props = __rest(_a, ["content", "query", "noUILink", "as", "domain", "locale", "replace", "scroll", "shallow", "prefetch", "children"]);

  var _useLink = useLink(),
      href = _useLink.href,
      as = _useLink.as;

  if (!content) {
    throw Error("Content is falsy");
  }

  var linkValue = react.useMemo(function () {
    return {
      href: href(content, {
        query: query
      }).replace("/index", "/") || "/",
      as: as(content, {
        query: query
      }) || "/"
    };
  }, [as, content, href, query]);
  return !domain && !locale ? jsxRuntime.jsx(NextLink__default['default'], Object.assign({}, linkValue, {
    passHref: true,
    scroll: scroll,
    replace: replace,
    shallow: shallow,
    prefetch: prefetch
  }, {
    children: noUILink ? children : jsxRuntime.jsx(As, Object.assign({}, props, {
      children: children
    }))
  })) : jsxRuntime.jsx(As, Object.assign({
    href: as(content, {
      query: query,
      domain: domain,
      locale: locale
    })
  }, props, {
    children: children
  }));
};

function _templateObject() {
  var data = _taggedTemplateLiteral__default['default'](["text-decoration: none;"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var RichtextValue = function RichtextValue(_a) {
  var value = _a.value,
      children = _a.children,
      props = __rest(_a, ["value", "children"]);

  var slate = useSlateValue(value);
  return (slate === null || slate === void 0 ? void 0 : slate.value) ? jsxRuntime.jsx(SlateValue, Object.assign({}, slate, {
    renderElement: renderElement,
    renderLeaf: renderLeaf,
    elementProps: props
  }, props)) : null;
};
var renderElement = function renderElement(_ref, repo) {
  var _paragraph = _ref._paragraph,
      _h1 = _ref._h1,
      _h2 = _ref._h2,
      _h3 = _ref._h3,
      _h4 = _ref._h4,
      _link = _ref._link,
      _img = _ref._img,
      _list = _ref._list;
  return function (_a) {
    var _b, _c;

    var children = _a.children,
        _d = _a.element,
        value = _d.children,
        element = __rest(_d, ["children"]),
        attributes = __rest(_a, ["children", "element"]);

    switch (element.type) {
      case "ul":
        return jsxRuntime.jsx(ui.List, Object.assign({}, _list, attributes, {
          children: children
        }));

      case "heading-one":
        {
          var id = getIdSlug(value);
          return jsxRuntime.jsx(Anchor, Object.assign({
            href: "#" + id
          }, {
            children: jsxRuntime.jsx(ui.Heading1, Object.assign({
              id: id
            }, _h1, attributes, element.styles, {
              children: children
            }))
          }));
        }

      case "heading-two":
        {
          var _id = getIdSlug(value);

          return jsxRuntime.jsx(Anchor, Object.assign({
            href: "#" + _id
          }, {
            children: jsxRuntime.jsx(ui.Heading2, Object.assign({
              id: _id
            }, _h2, attributes, element.styles, {
              children: children
            }))
          }));
        }

      case "heading-three":
        {
          var _id2 = getIdSlug(value);

          return jsxRuntime.jsx(Anchor, Object.assign({
            href: "#" + _id2
          }, {
            children: jsxRuntime.jsx(ui.Heading3, Object.assign({
              id: _id2
            }, _h3, attributes, element.styles, {
              children: children
            }))
          }));
        }

      case "heading-four":
        {
          var _id3 = getIdSlug(value);

          return jsxRuntime.jsx(Anchor, Object.assign({
            href: "#" + _id3
          }, {
            children: jsxRuntime.jsx(ui.Heading4, Object.assign({
              id: _id3
            }, _h4, attributes, element.styles, {
              children: children
            }))
          }));
        }

      case "li":
        return jsxRuntime.jsx("li", Object.assign({}, attributes, {
          children: jsxRuntime.jsx("div", {
            children: children
          })
        }));

      case "ol":
        return jsxRuntime.jsx("ol", Object.assign({}, attributes, {
          children: children
        }));

      case "link":
        return element.linkType === "external" ? jsxRuntime.jsx(ui.Link, Object.assign({}, attributes, {
          href: element.url
        }, element.styles, ((_b = element.styles) === null || _b === void 0 ? void 0 : _b.target) && {
          rel: "noopener noreferrer"
        }, _link, {
          children: children
        })) : jsxRuntime.jsx(Link, Object.assign({}, attributes, _link, {
          content: repo[element.content]
        }, element.styles, {
          children: children
        }));

      case "paragraph":
        return jsxRuntime.jsx(ui.Typography, Object.assign({
          variant: "p"
        }, _paragraph, attributes, element.styles, {
          children: children
        }));

      case "button":
        return element.linkType === "external" ? jsxRuntime.jsx(ui.Button, Object.assign({
          as: "a"
        }, attributes, {
          href: element.url
        }, element.styles, ((_c = element.styles) === null || _c === void 0 ? void 0 : _c.target) && {
          rel: "noopener noreferrer"
        }, _link, {
          children: children
        })) : jsxRuntime.jsx(Link, Object.assign({}, attributes, _link, {
          content: repo[element.content]
        }, element.styles, {
          as: ui.Button
        }, {
          children: children
        }));

      case "html":
        return jsxRuntime.jsx("div", {
          dangerouslySetInnerHTML: {
            __html: element.src
          }
        });

      case "img":
        return jsxRuntime.jsxs(ui.Flex, Object.assign({}, attributes, {
          justifyContent: "center"
        }, {
          children: [jsxRuntime.jsx(ui.Box, Object.assign({
            as: "img"
          }, element, {
            maxHeight: "20rem"
          }, _img)), children]
        }));

      default:
        return jsxRuntime.jsx(ui.Typography, Object.assign({
          variant: "p"
        }, _paragraph, attributes, element.styles, {
          children: children
        }));
    }
  };
}; // TODO: fix types

var renderLeaf = function renderLeaf(_ref2) {
  var _strong = _ref2._strong;
  return function (_ref3) {
    var attributes = _ref3.attributes,
        children = _ref3.children,
        leaf = _ref3.leaf;

    if (leaf.bold) {
      children = jsxRuntime.jsx(ui.Text, Object.assign({
        variant: "strong",
        fontSize: "inherit"
      }, _strong, {
        children: children
      }));
    }

    if (leaf.italic) {
      children = jsxRuntime.jsx("em", {
        children: children
      });
    }

    if (leaf.sub) {
      children = jsxRuntime.jsx("sub", {
        children: children
      });
    }

    if (leaf.sup) {
      children = jsxRuntime.jsx("sup", {
        children: children
      });
    }

    if (leaf.underline) {
      children = jsxRuntime.jsx("u", {
        children: children
      });
    }

    if (leaf.strikethrough) {
      children = jsxRuntime.jsx("del", {
        children: children
      });
    }

    if (leaf.color) {
      children = jsxRuntime.jsx("span", Object.assign({
        style: {
          color: leaf.color
        }
      }, {
        children: children
      }));
    }

    return jsxRuntime.jsx("span", Object.assign({}, attributes, {
      children: children
    }));
  };
};
var Anchor = styled__default['default'].a(_templateObject());
var getIdSlug = function getIdSlug(value) {
  return _getSlug__default['default'](value.map(function (child) {
    return child.text;
  }).join(""), {
    truncate: 50
  });
};

var InlineValue = function InlineValue(p) {
  var _useData = useData(),
      stringify = _useData.stringify;

  return jsxRuntime.jsx(jsxRuntime.Fragment, {
    children: stringify(p.value)
  });
};

var handlerObject = function handlerObject(source, set) {
  return new Proxy({}, {
    get: function get(_, k) {
      return k === Symbol.toPrimitive || k === Symbol.toStringTag ? toPrimitive(source) : k === "__handler" ? handler(source, set) : getHandler(source[k], function (v) {
        return set(Object.assign(Object.assign({}, source), _defineProperty__default['default']({}, k, v)));
      });
    },
    ownKeys: function ownKeys() {
      return ["__handler"].concat(_toConsumableArray__default['default'](Object.keys(source)));
    },
    has: function has(_, key) {
      return key === "__handler" || key in source;
    }
  });
};
var toHandler = function toHandler(value, set) {
  return {
    __handler: handler(value, set !== null && set !== void 0 ? set : function () {})
  };
};

var getHandler = function getHandler(value, set) {
  return value === null || value === undefined ? value : Array.isArray(value) ? handlerArray(value, set) : handlerObject(value, set);
};

var handlerArray = function handlerArray(value, set) {
  var a = value.map(function (v, i) {
    return getHandler(v, function (val) {
      return set(value.map(function (x, ii) {
        return i === ii ? val : x;
      }));
    });
  });
  a.__handler = handler(value, set);
  return a;
};

var handler = function handler(value, setValue) {
  return [value, setValue];
};

var toPrimitive = function toPrimitive(source) {
  return function (hint) {
    console.trace("Handler is being coverted to primitive! Source:", source);
    return hint === "number" ? 1337 : "[Handler handler]";
  };
};

/**
 * Creates a ctx object which is available in getXcoreProps or getXcoreServerProps functions
 */

var createXcoreContext = function createXcoreContext(ctx) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
    var config, isPreview, cms, q;
    return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return xcoreCore.getXcoreConfig();

          case 2:
            config = _context.sent;
            isPreview = ctx.preview && ctx.previewData && _typeof__default['default'](ctx.previewData) === "object" && "authToken" in ctx.previewData;
            cms = config.getCMS(ctx.locale, isPreview ? {
              authToken: ctx.previewData.authToken
            } : {});
            q = Object.assign(Object.assign({}, ctx.params), "query" in ctx ? ctx.query : {});
            return _context.abrupt("return", Object.assign(Object.assign({}, ctx), {
              cms: cms,
              id: +xcoreCore.only(q.id) || undefined,
              slug: xcoreCore.only(q.slug)
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var mergeServerProps = function mergeServerProps(layout, props) {
  return function (ctx) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
      var _yield$Promise$all, _yield$Promise$all2, a, b;

      return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([layout === null || layout === void 0 ? void 0 : layout(ctx), props === null || props === void 0 ? void 0 : props(ctx)]);

            case 2:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray__default['default'](_yield$Promise$all, 2);
              a = _yield$Promise$all2[0];
              b = _yield$Promise$all2[1];
              return _context.abrupt("return", mergeProps(a, b));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};
var mergeStaticProps = function mergeStaticProps(config, layout, props) {
  return function (ctx) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2() {
      var _yield$Promise$all3, _yield$Promise$all4, a, b;

      return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Promise.all([layout === null || layout === void 0 ? void 0 : layout(ctx), props === null || props === void 0 ? void 0 : props(ctx)]);

            case 2:
              _yield$Promise$all3 = _context2.sent;
              _yield$Promise$all4 = _slicedToArray__default['default'](_yield$Promise$all3, 2);
              a = _yield$Promise$all4[0];
              b = _yield$Promise$all4[1];
              return _context2.abrupt("return", revalidateProps(config.revalidate, mergeProps(a, b)));

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };
};

var mergeProps = function mergeProps(layout, result) {
  if (result === undefined) return {
    props: layout
  };

  if (isOk(result)) {
    if (isPromiseLike(result.props)) {
      // @ts-ignore
      return Object.assign(Object.assign({}, result), {
        props: result.props.then(function (x) {
          return Object.assign(Object.assign({}, x), {
            layout: layout
          });
        })
      });
    } else {
      return Object.assign(Object.assign({}, result), {
        props: Object.assign(Object.assign({}, result.props), layout)
      });
    }
  }

  if (isNotFound(result)) {
    return result;
  }

  if (isRedirect(result)) {
    return result;
  }

  return result;
};

var isOk = function isOk(a) {
  return a && "props" in a;
};

var isNotFound = function isNotFound(a) {
  return a && "notFound" in a;
};

var isRedirect = function isRedirect(a) {
  return a && "redirect" in a;
};

var isPromiseLike = function isPromiseLike(a) {
  return "then" in a && typeof a.then === "function";
};

var revalidateProps = function revalidateProps(revalidate, props) {
  return Object.assign(Object.assign({}, props), {
    revalidate: revalidate !== null && revalidate !== void 0 ? revalidate : 10
  });
};

/** Asynchronously fetch all data user supplied in their getXcoreProps / getXcoreServerProps */

var resolveOptions = function resolveOptions(pageId, options, config) {
  return function (_ref) {
    var cms = _ref.cms,
        id = _ref.id,
        locale = _ref.locale;
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
      var _a, _b, _c, _d, _e, _f, _yield$Promise$all, _yield$Promise$all2, contentTypes, pageContent, content, contents, categories, data, d;

      return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return options;

            case 2:
              options = _context.sent;
              _context.next = 5;
              return Promise.all([cms.contentTypes(true), resolvePageContent(cms, id, pageId, options.pageContent, options.relations, options.reverseRelations), Promise.all((_a = options.content) !== null && _a !== void 0 ? _a : []).then(function (r) {
                return r.map(function (c) {
                  return c === null || c === void 0 ? void 0 : c.content;
                });
              }), Promise.all((_b = options.contents) !== null && _b !== void 0 ? _b : []).then(function (res) {
                return res.map(function (_ref2) {
                  var c = _ref2.contents,
                      o = _ref2.options;
                  return {
                    contents: c,
                    options: o
                  };
                });
              }), Promise.all((_c = options.categories) !== null && _c !== void 0 ? _c : []), (_d = options.data) === null || _d === void 0 ? void 0 : _d.call(options)]);

            case 5:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray__default['default'](_yield$Promise$all, 6);
              contentTypes = _yield$Promise$all2[0];
              pageContent = _yield$Promise$all2[1];
              content = _yield$Promise$all2[2];
              contents = _yield$Promise$all2[3];
              categories = _yield$Promise$all2[4];
              data = _yield$Promise$all2[5];

              if (pageContent) {
                _context.next = 15;
                break;
              }

              return _context.abrupt("return", {
                notFound: true
              });

            case 15:
              d = (_e = Object.entries(config.getResolvedDomains()).find(function (_ref3) {
                var _ref4 = _slicedToArray__default['default'](_ref3, 2),
                    _ = _ref4[0],
                    l = _ref4[1];

                return l === locale;
              })) === null || _e === void 0 ? void 0 : _e[0];
              return _context.abrupt("return", {
                props: Object.assign(Object.assign({
                  _xcoreProps: true,
                  contentTypes: mapContentTypes(contentTypes),
                  pageContent: pageContent,
                  content: content,
                  contents: contents,
                  categories: categories.map(function (c) {
                    return c.categories;
                  }),
                  data: (_f = data) !== null && _f !== void 0 ? _f : {},
                  ctx: cms.getSerializableCtx()
                }, d ? {
                  domain: d
                } : undefined), {
                  config: config.value
                })
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
};

var mapContentTypes = function mapContentTypes(contentTypes) {
  return contentTypes.filter(Boolean).flat().reduce(function (acc, val) {
    acc[val.id] = val;
    return acc;
  }, {});
};

var resolvePageContent = function resolvePageContent(cms, id, pageId, pageContent, relations, reverseRelations) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2() {
    var _g, resolved, pcPromise, pc;

    return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(pageContent !== undefined)) {
              _context2.next = 21;
              break;
            }

            if (!(typeof pageContent === "string" || typeof pageContent === "number")) {
              _context2.next = 14;
              break;
            }

            _context2.next = 4;
            return cms.content.single(pageContent, {
              preview: true,
              fetchRichtextLinks: true
            });

          case 4:
            _context2.t1 = _g = _context2.sent;
            _context2.t0 = _context2.t1 === null;

            if (_context2.t0) {
              _context2.next = 8;
              break;
            }

            _context2.t0 = _g === void 0;

          case 8:
            if (!_context2.t0) {
              _context2.next = 12;
              break;
            }

            _context2.t2 = void 0;
            _context2.next = 13;
            break;

          case 12:
            _context2.t2 = _g.content;

          case 13:
            return _context2.abrupt("return", _context2.t2);

          case 14:
            _context2.next = 16;
            return pageContent;

          case 16:
            resolved = _context2.sent;

            if (!resolved) {
              _context2.next = 19;
              break;
            }

            return _context2.abrupt("return", resolved.content);

          case 19:
            _context2.next = 31;
            break;

          case 21:
            logWarn("GetStaticProps without pageContent field are deprecated, please provide explicit pageContent", true);

            if (Object.is(+id, NaN)) {
              if (pageId == null) logError("PageId is required for automatic pageContent fetching", true);
              pcPromise = cms.routing.pageContent(pageId).then(function (c) {
                return c ? xcoreCore.fetchRichtextLinks(c, cms) : c;
              });
            } else {
              pcPromise = cms.content.single(+id, {
                fetchRichtextLinks: true,
                preview: true
              }).then(function (r) {
                var _a;

                return (_a = r === null || r === void 0 ? void 0 : r.content) !== null && _a !== void 0 ? _a : null;
              });
            }

            _context2.next = 25;
            return pcPromise;

          case 25:
            pc = _context2.sent;

            if (pc) {
              _context2.next = 28;
              break;
            }

            return _context2.abrupt("return", null);

          case 28:
            _context2.next = 30;
            return xcoreCore.resolveContent([pc], cms, relations, reverseRelations);

          case 30:
            return _context2.abrupt("return", _context2.sent[0]);

          case 31:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

var getXcoreProps = function getXcoreProps(layoutData) {
  return function (_pageId, _getOptions) {
    var _normalizeArguments = normalizeArguments(_pageId, _getOptions),
        _normalizeArguments2 = _slicedToArray__default['default'](_normalizeArguments, 2),
        pageId = _normalizeArguments2[0],
        getOptions = _normalizeArguments2[1];

    return function (c) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
        var config, ctx, options;
        return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return xcoreCore.getXcoreConfig();

              case 2:
                config = _context.sent;
                _context.next = 5;
                return createXcoreContext(c);

              case 5:
                ctx = _context.sent;
                // Calling user supplied getOptions function
                options = getOptions === null || getOptions === void 0 ? void 0 : getOptions(ctx);
                _context.next = 9;
                return mergeStaticProps(config, layoutData, resolveOptions(pageId, options !== null && options !== void 0 ? options : {}, config))(ctx);

              case 9:
                return _context.abrupt("return", _context.sent);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };
  };
};
var getXcoreServerProps = function getXcoreServerProps(layoutData) {
  return function (_pageId, _getOptions) {
    var _normalizeArguments3 = normalizeArguments(_pageId, _getOptions),
        _normalizeArguments4 = _slicedToArray__default['default'](_normalizeArguments3, 2),
        pageId = _normalizeArguments4[0],
        getOptions = _normalizeArguments4[1];

    return function (c) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee2() {
        var config, ctx, options;
        return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return xcoreCore.getXcoreConfig();

              case 2:
                config = _context2.sent;
                _context2.next = 5;
                return createXcoreContext(c);

              case 5:
                ctx = _context2.sent;
                options = getOptions === null || getOptions === void 0 ? void 0 : getOptions(ctx);
                _context2.next = 9;
                return mergeServerProps(layoutData, resolveOptions(pageId, options !== null && options !== void 0 ? options : {}, config))(ctx);

              case 9:
                return _context2.abrupt("return", _context2.sent);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    };
  };
};
/** Normalizes both ways to call the getXcoreProps to a tuple of 2 elements */

var normalizeArguments = function normalizeArguments(_pageId, _getOptions) {
  var pageId = typeof _pageId === "function" ? null : _pageId;
  var getOptions = typeof _pageId === "function" ? _pageId : _getOptions;
  return [pageId, getOptions];
};

/**
 * usePage returns content of the xcore context with SSG/SSR props and utilities,
 * but the contents from the content field are wrapped in handlers
 */

var usePage = function usePage() {
  var _a = useData(),
      pageContent = _a.pageContent,
      content = _a.content,
      setContent = _a.setContent,
      context = __rest(_a, ["pageContent", "content", "setContent"]);

  return Object.assign(Object.assign({}, context), {
    pageContent: contentWithHandlers(pageContent, function () {}),
    content: content.map(function (c, i) {
      return contentWithHandlers(c, function (val) {
        return setContent(content.map(function (cc, ii) {
          return i === ii ? val : cc;
        }));
      });
    })
  });
};

var contentWithHandlers = function contentWithHandlers(content, set) {
  return Object.assign(Object.assign({}, content), {
    values: handlerObject(content.values, function (values) {
      return set(Object.assign(Object.assign({}, content), {
        values: values
      }));
    })
  });
};

/**
 * useContent hook returns the content of the current page
 */

var usePageContent = function usePageContent() {
  var _a = usePage(),
      pageContent = _a.pageContent,
      utils = __rest(_a, ["pageContent"]);

  return [pageContent, utils];
};

/**
 * useContent returns the contents fetched in the contents field
 */

var useContent = function useContent() {
  var _usePage = usePage(),
      content = _usePage.content;

  return content;
};

/**
 * useContents returns the contents fetched in the contents field
 */

var useContents = function useContents() {
  var _usePage = usePage(),
      contents = _usePage.contents;

  return react.useMemo(function () {
    return contents.map(function (c) {
      return c.contents;
    });
  }, [contents]);
};

/**
 * useCategories returns first fetched set of categories fetched in the categories field.
 */

var useCategories = function useCategories() {
  var _usePage = usePage(),
      categories = _usePage.categories;

  return categories;
};

var useSSRSafeEffect = typeof window === "undefined" ? react.useEffect : react.useLayoutEffect;
var useRequestContext = function useRequestContext() {
  var rq = react.useContext(ReactRequestContext);
  var swr = useSWR.useSWRConfig(); // eslint-disable-next-line react-hooks/exhaustive-deps

  var val = react.useMemo(function () {
    return Object.assign(Object.assign({}, rq), {
      swr: swr
    });
  }, [rq]);
  useSSRSafeEffect(function () {
    return void (val.swr = swr);
  });
  return val;
};
var useXcoreCMS = function useXcoreCMS() {
  var ctx = useRequestContext();
  return react.useMemo(function () {
    return new xcoreCore.XcoreCMS(ctx);
  }, [ctx]);
};

var useXcoreQuery = function useXcoreQuery(req, config) {
  var _a;

  var _b = useRequestContext(),
      swr = _b.swr,
      ctxContext = __rest(_b, ["swr"]);

  var ctx = react.useMemo(function () {
    return Object.assign(Object.assign({}, ctxContext), config === null || config === void 0 ? void 0 : config.ctx);
  }, [config === null || config === void 0 ? void 0 : config.ctx, ctxContext]);
  var query = react.useMemo(function () {
    if (ctx === null) {
      // eslint-disable-next-line max-len
      throw new Error("Request context is not specified. Use either RequestContextProvider or XcoreClientProvider to provide context. Or pass ctx option in the configuration object.");
    }

    var cms = new xcoreCore.XcoreCMS(Object.assign(Object.assign({}, ctx), {
      requestHandler: function requestHandler(reqUrl) {
        return xcoreCore.noopPromise(reqUrl, Promise.resolve({
          noop: true
        }));
      }
    }));
    return req(cms);
  }, [ctx, req]);
  return useSWR__default['default']((_a = query === null || query === void 0 ? void 0 : query.url) !== null && _a !== void 0 ? _a : null, function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
      var _c, cms;

      return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cms = new xcoreCore.XcoreCMS(ctx);
              _context.next = 3;
              return (_c = req(cms)) === null || _c === void 0 ? void 0 : _c["catch"](function (e) {
                var _a;

                (_a = ctx.onError) === null || _a === void 0 ? void 0 : _a.call(ctx, e);
                throw e;
              });

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }, config);
};

var useXcoreUtils = function useXcoreUtils() {
  var cms = useXcoreCMS();
  return react.useMemo(function () {
    return xcoreDataUtils(cms);
  }, [cms]);
};

var previewApiHandler = function previewApiHandler(req, res) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime__default['default'].mark(function _callee() {
    var config, locale, authToken, cms, contentTypes, content, link;
    return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!req.query.secret || !req.query.id || !req.query.locale)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", res.status(401).json({
              message: "Invalid token"
            }));

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return xcoreCore.getXcoreConfig();

          case 5:
            config = _context.sent;
            locale = xcoreCore.only(req.query.locale);
            authToken = xcoreCore.only(req.query.secret);
            cms = config.getCMS(locale, {
              published: false,
              authToken: authToken
            });
            _context.next = 11;
            return cms.contentTypes(true);

          case 11:
            contentTypes = _context.sent;
            _context.next = 14;
            return cms.content.single(xcoreCore.only(req.query.id));

          case 14:
            content = _context.sent;

            if (content) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return", res.status(401).json({
              message: "Invalid id"
            }));

          case 17:
            res.setPreviewData({
              authToken: authToken
            });
            link = createXcoreLink({
              cms: cms,
              config: config,
              contentTypes: Object.fromEntries(contentTypes.map(function (ct) {
                return [ct.id, ct];
              })),
              resolvedDomains: config.getResolvedDomains(req.headers.host)
            });
            res.redirect(link.as(content.content, {
              locale: locale
            }));
            _context.next = 25;
            break;

          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](2);
            res.status(400).end("".concat(_context.t0));

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 22]]);
  }));
};

typeof window !== "undefined" && (window.__$XCORE_CLIENT_UILIB_XCORE = true);

if (process.env.NODE_ENV !== "production" && // @ts-ignore
typeof __$XCORE_CLIENT_UILIB_ANOLIS !== "undefined") {
  // eslint-disable-next-line max-len
  var warning = "Is seems that you are using @appiodev/xcore-client with both anolis-ui and @xcorejs/ui. This is unsupported and may cause unexpected behavior. Check your @appiodev/xcore-client imports. To disable use XCORE_BYPASS_UILIB_WARNING env var.";

  if (!process.env.XCORE_BYPASS_UILIB_WARNING) {
    throw new Error(warning);
  } else {
    console.warn(warning);
  }
}

Object.keys(xcoreUtils).forEach(function (k) {
    if (k !== 'default') Object.defineProperty(exports, k, {
        enumerable: true,
        get: function () {
            return xcoreUtils[k];
        }
    });
});
exports.Anchor = Anchor;
exports.ERROR404_CONTENT_TYPE_NAME = ERROR404_CONTENT_TYPE_NAME;
exports.InlineValue = InlineValue;
exports.Link = Link;
exports.ReactRequestContext = ReactRequestContext;
exports.RequestContextProvider = RequestContextProvider;
exports.RichtextValue = RichtextValue;
exports.SlateValue = SlateValue;
exports.UNAVAILABLE_LOCALE_CONTENT_TYPE_NAME = UNAVAILABLE_LOCALE_CONTENT_TYPE_NAME;
exports.XcoreClientProvider = XcoreClientProvider;
exports.XcoreDataContext = XcoreDataContext;
exports.createXcoreLink = createXcoreLink;
exports.getIdSlug = getIdSlug;
exports.getXcoreProps = getXcoreProps;
exports.getXcoreServerProps = getXcoreServerProps;
exports.handlerObject = handlerObject;
exports.previewApiHandler = previewApiHandler;
exports.renderElement = renderElement;
exports.renderLeaf = renderLeaf;
exports.toHandler = toHandler;
exports.useCategories = useCategories;
exports.useContent = useContent;
exports.useContents = useContents;
exports.useData = useData;
exports.useLink = useLink;
exports.usePage = usePage;
exports.usePageContent = usePageContent;
exports.useRequestContext = useRequestContext;
exports.useSlateValue = useSlateValue;
exports.useXcoreCMS = useXcoreCMS;
exports.useXcoreQuery = useXcoreQuery;
exports.useXcoreUtils = useXcoreUtils;
exports.xcoreDataUtils = xcoreDataUtils;
//# sourceMappingURL=xcore-ui.js.map
